/**
 * Phone number utilities — converts Arabic-Indic numerals (٠-٩) to ASCII
 * digits so users on an Arabic keyboard don't need to switch to English
 * just to type a phone number.
 */

const ARABIC_TO_ASCII = {
  "\u0660": "0", "\u0661": "1", "\u0662": "2", "\u0663": "3", "\u0664": "4",
  "\u0665": "5", "\u0666": "6", "\u0667": "7", "\u0668": "8", "\u0669": "9",
};

const ARABIC_DIGIT_RE = /[\u0660-\u0669]/g;

/**
 * Convert Arabic-Indic numerals (٠-٩) to ASCII digits (0-9).
 * ASCII digits and all other characters pass through unchanged.
 *
 * @param {string} text
 * @returns {string}
 */
export function convertArabicNumerals(text) {
  if (!text) return text;
  return text.replace(ARABIC_DIGIT_RE, (ch) => ARABIC_TO_ASCII[ch] ?? ch);
}
